/**
 * Resolves a server-relative upload path (e.g. "/uploads/avatars/foo.png")
 * to a fully-qualified URL against the backend API origin.
 *
 * If the path is already an absolute URL it is returned unchanged.
 * Returns undefined / null unchanged so Avatar components can fall back to initials.
 */
const API_ORIGIN = (() => {
  const url = import.meta.env.VITE_API_URL as string | undefined;
  if (!url) return '';
  // Strip trailing "/api" (or "/api/") segment to get the bare origin
  return url.replace(/\/api\/?$/, '');
})();

export function resolveFileUrl(path: string | null | undefined): string | undefined {
  if (!path) return undefined;
  if (/^https?:\/\//i.test(path)) return path; // already absolute
  // Ensure a single leading slash
  const normalised = path.startsWith('/') ? path : `/${path}`;
  return `${API_ORIGIN}${normalised}`;
}
